import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Phone } from "lucide-react";
import { NAV_LINKS, PHONE_DISPLAY, PHONE_TEL } from "../data/content";

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-ink/10 bg-white/95 backdrop-blur">
      <nav className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4 sm:px-8">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center gap-2.5"
          onClick={() => setOpen(false)}
        >
          <img
            src="/images/logo.png"
            alt="Easyskip logo"
            className="h-9 w-9 object-contain"
          />
          <span className="font-heading text-2xl font-extrabold tracking-tight text-ink">
            Easyskip
          </span>
        </Link>

        <div className="hidden items-center gap-8 md:flex">
          {NAV_LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors duration-200 ${
                  isActive ? "text-emerald-700" : "text-ink/65 hover:text-ink"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </div>

        <div className="hidden items-center gap-5 md:flex">
          <a
            href={PHONE_TEL}
            data-testid="nav-phone-link"
            className="flex items-center gap-2 text-sm font-semibold text-ink transition-colors duration-200 hover:text-emerald-700"
          >
            <Phone className="h-4 w-4" />
            {PHONE_DISPLAY}
          </a>
          <Link
            to="/prices"
            data-testid="nav-book-skip-button"
            className="rounded-full bg-ink px-5 py-2.5 font-heading text-sm font-bold text-white transition-colors duration-200 hover:bg-emerald-800"
          >
            Book a Skip
          </Link>
        </div>

        <button
          className="flex h-10 w-10 items-center justify-center rounded-lg border border-ink/15 text-ink md:hidden"
          data-testid="nav-mobile-menu-button"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden border-t border-ink/10 bg-white md:hidden"
          >
            <div className="space-y-1 px-5 py-5">
              {NAV_LINKS.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                  onClick={() => setOpen(false)}
                  className="block rounded-lg px-3 py-3 font-heading text-lg font-semibold text-ink transition-colors duration-200 hover:bg-black/5"
                >
                  {l.label}
                </NavLink>
              ))}
              <a
                href={PHONE_TEL}
                data-testid="mobile-nav-phone-link"
                className="mt-2 flex items-center justify-center gap-2 rounded-full bg-ink px-6 py-3 font-heading text-sm font-bold text-white"
              >
                <Phone className="h-4 w-4" />
                Call {PHONE_DISPLAY}
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};
